/**
 * Ручки auth, которыми пользуется трекер. Сервис общий с CRM, поэтому и
 * контракт тот же — включая две его особенности:
 *
 * — логин принимает поле `username`, хотя в нём почта;
 * — refresh читает токен из заголовка `Refresh-Token`, тело не смотрит.
 */
import { http } from '@/api/http'

import type { LoginResponse, User } from './types'

export const authApi = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const { data } = await http.post<LoginResponse>('/api/v1/auth/login', {
      username: email,
      password,
    })

    return data
  },

  async logout(): Promise<void> {
    await http.post('/api/v1/auth/logout')
  },

  async me(): Promise<User> {
    const { data } = await http.get<User>('/api/v1/auth/me')

    return data
  },
}
